import { privacy } from "@redotech/schema-privacy";
import * as z from "zod";
import { DateFromDateOrIsoStringSchema } from "./date-schema";

const MarketplaceNotificationStatusSchema_ = z
  .discriminatedUnion("status", [
    z
      .object({
        status: z.literal("complete").meta({ privacy: privacy.nonPii }),
      })
      .meta({ privacy: privacy.structured }),
    z
      .object({
        status: z.literal("skipped").meta({ privacy: privacy.nonPii }),
      })
      .meta({ privacy: privacy.structured }),
    z
      .object({
        status: z.literal("pending").meta({ privacy: privacy.nonPii }),
        date: DateFromDateOrIsoStringSchema.nullish().meta({
          privacy: privacy.nonPii,
        }),
      })
      .meta({ privacy: privacy.structured }),
    z
      .object({
        status: z.literal("failed").meta({ privacy: privacy.nonPii }),
        actionMessage: z.string().meta({ privacy: privacy.free_text }),
      })
      .meta({ privacy: privacy.structured }),
  ])
  .meta({ privacy: privacy.structured });
export const MarketplaceNotificationStatusSchema: z.ZodType<MarketplaceNotificationStatus> =
  MarketplaceNotificationStatusSchema_;

export type MarketplaceNotificationStatus = z.infer<
  typeof MarketplaceNotificationStatusSchema_
>;

export interface IMarketplaceNotificationStatus extends z.ZodType<MarketplaceNotificationStatus> {}
